import { css, type Theme } from "@emotion/react";

export const panel = (theme: Theme) => css`
  background-color: ${theme.system.backgroundMuted};
  padding: 0 1.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const image = css`
  width: 100%;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
`;

export const title = css`
  margin-bottom: 0.75rem;
`;

export const list = css`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const listItem = css`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
`;

export const checkIcon = (theme: Theme) => css`
  color: ${theme.success.textBase};
  flex-shrink: 0;
  margin-top: 0.125rem;
`;
